import aL01 from '../game-01-weltraum-maus/assets/L01.png'

const url =
  'https://wdradaptiv-vh.akamaihd.net/i/medp/ondemand/weltweit/fsk0/213/2136925/,2136925_26555778,2136925_26555773,2136925_26555775,2136925_26555774,2136925_26555777,2136925_26555776,.mp4.csmil/master.m3u8'

export default {
  id: '07',
  name: 'Die Weltraum-Maus (2/10)',
  subtitle: 'Lasse die Maus durchs Weltall fliegen',
  image: aL01,
  video: url,
}
